<div class="public-card-property {{ size }}">
	<a [href]="property.url" [attr.rel]="nofollow ? 'nofollow' : null">
		<div class="public-card-property__tags">
			<span class="for-sale" *ngIf="!property.lease">{{ 'listing.forSale' | translate }}</span>
			<span class="for-rent" *ngIf="property.lease">{{ 'listing.forRent' | translate }}</span>
		</div>
		<img [src]="property.imageUrl" alt="{{ property.address }}" class="public-card-property__image" />
	</a>
	<div class="public-card-property__content">
		<div class="price">{{ formatPrice(property.price) }}</div>
		<div class="items">
			<div class="item" *ngIf="property.bedrooms > 0">
				<strong>{{ property.bedrooms }}</strong> bds
			</div>
			<div class="item" *ngIf="property.bathrooms && property.bathrooms !== '0'">
				<strong>{{ property.bathrooms }}</strong> ba
			</div>
			<div class="item" *ngIf="property.squareFootage > 0">
				<strong>{{ property.squareFootage | number : '1.0-0' }}</strong> sqft
			</div>
		</div>
		<div class="address">{{ property.address }}</div>
	</div>
</div>
